import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  margin: 0 auto;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100%;
  padding-left: ${(props) => (props.sidebar != false ? "160px" : "0px")};
  background: #fff;

  @media (max-width: 800px) {
    padding-left: 0px;
    width: 90%;
  }
`;
